module.exports = __webpack_public_path__ + "static/media/logo-sgr-white.7ed19d1b.svg";